/**
 * Acelera Clerk en /admin: preconnect + prefetch del entry clerk-js antes del login UI.
 */

import { BRAND_SITE_HOST } from "@/lib/brandConfig";
import { getClerkPublishableKey } from "@/lib/clerkPublishableKey";

const PRECONNECT_MARK = "data-admin-clerk-preconnect";
const PREFETCH_MARK = "data-admin-clerk-prefetch";

export function getClerkAssetOrigin(): string {
  const host = (BRAND_SITE_HOST || "delfuocampo.com").replace(/^www\./, "");
  return `https://clerk.${host}`;
}

function ensureLink(rel: string, href: string, mark: string, as?: string): void {
  if (typeof document === "undefined") return;
  if (document.querySelector(`link[${mark}]`)) return;
  const link = document.createElement("link");
  link.rel = rel;
  link.href = href;
  link.setAttribute(mark, "1");
  if (rel === "preconnect" || rel === "dns-prefetch") {
    link.crossOrigin = "anonymous";
  }
  if (as) link.as = as;
  document.head.appendChild(link);
}

/**
 * Llamar al entrar al shell admin (main.tsx + ProtectedAdminRoute + AdminLayout).
 */
export function preloadClerkForAdmin(): void {
  if (typeof window === "undefined") return;
  if (!getClerkPublishableKey()) return;

  const origin = getClerkAssetOrigin();
  ensureLink("dns-prefetch", origin, PRECONNECT_MARK);
  ensureLink("preconnect", origin, PRECONNECT_MARK);

  // Entry clerk-js (versión la resuelve el proxy de Clerk en runtime).
  const clerkEntry = `${origin}/npm/@clerk/clerk-js@5/dist/clerk.browser.js`;
  ensureLink("prefetch", clerkEntry, PREFETCH_MARK, "script");
}
